import startCase from 'lodash/startCase';

export const humanizeCategory = (category: string) =>
  startCase(category.toLowerCase());
